import React from 'react';
import { MenuItem } from '@material-ui/core';
import { Typography } from '../Typography';
import { Options } from '../../components/forms/fields/types';
import { StyledTableHeadSelect } from './style';

interface TableHeadSelectProps {
    label: string;
    options: Options[];
    onChange(val: string | null): void;
    value: string | null;
    fullWidth?: boolean;
}

const TableHeadSelect = ({ label, value, options, onChange, fullWidth }: TableHeadSelectProps) => {
    const handleSelectChange = (e: React.ChangeEvent<{ name?: string | undefined; value: unknown }>) => {
        const { value: val } = e.target;
        if (val === 'null') {
            return onChange(null);
        }
        return onChange(val as string);
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const renderValue = (val: any) => val === 'null'
        ? <Typography uppercase color='textSecondary' variant='caption'>{label}</Typography>
        : options.find(o => o.id === val)?.name;

    return (
        <StyledTableHeadSelect
            onChange={handleSelectChange}
            fullWidth={fullWidth}
            disableUnderline
            value={value === null ? 'null' : value}
            renderValue={renderValue}
            MenuProps={{
                anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left'
                },
                transformOrigin: {
                vertical: 'top',
                horizontal: 'left'
                },
                getContentAnchorEl: null
            }}
        >
            <MenuItem value='null'>&mdash;</MenuItem>
            {options.map(option => (
                <MenuItem key={option.id} value={option.id}>{option.name}</MenuItem>
            ))}
        </StyledTableHeadSelect>
    );
};

export default TableHeadSelect;